import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Animations from "./animations";
import VideoModule from "./videoModule";
import Header from "./header";

const Hero = (() => {

    const SELECTOR_MODULE = '.module-container__hero';

    const initialize = () => {

        const module = document.querySelector(SELECTOR_MODULE);

        if (!module) return;

        initAnimations(module);

    };

    const initAnimations = module => {

        const animated = module.querySelector(".content__text");
        const videoEl = module.querySelector(VideoModule.SELECTOR_MODULE);
        

        let mm = gsap.matchMedia();

        mm.add({
            md: "(max-width: 991px)",
            lg: "(min-width: 992px) and (max-width: 1199px)",
            xl: "(min-width: 1200px) and (max-width: 1399px)",
            xxl: "(min-width: 1400px)"

        }, (ctx) => {
            let { md, lg, xl, xxl } = ctx.conditions;
            let tl = gsap.timeline();

            if (md) {
                tl.add(Animations.revealElements(animated, {}, { duration: 1.5 }));
            } else {
                tl
                    .to({}, {}, "+=1")
                    .add(Animations.revealElements(animated, { y: () => animated.offsetHeight }, { duration: 1.5, y: () => Header.getCurrentHeight() }));    
            }
            

            /* if (lg) {
                tl
                    .to({}, {}, "+=1")
                    .add(Animations.revealElements(animated, { y: 0 }, { duration: 1.5, yPercent: -30 }));
            }
            if (xl) {
                tl
                    .to({}, {}, "+=1")
                    .add(Animations.revealElements(animated, { y: 0 }, { duration: 1.5, yPercent: -40 }));
            }
            if (xxl) {
                tl
                    .to({}, {}, "+=1")
                    .add(Animations.revealElements(animated, { y: 0 }, { duration: 1.5, yPercent: -50 }));
            } */


            

            if (!videoEl) {
                const pictureEl = module.querySelector('.content__media picture');
                const imgEl = pictureEl.querySelector('img');

                pictureEl.addEventListener('click', () => {

                    Animations.heartbeatElements(pictureEl, { repeat: 2, repeatDelay: .1});
                });
                tl.add(Animations.revealElements(imgEl, {y: 0, autoAlpha: 0}, { duration: 1, autoAlpha: 1 }))
                tl.add(gsap.to({},{}, "+=1"))
                tl.add(Animations.heartbeatElements(pictureEl, { repeat: 2, repeatDelay: .1}));
            }
            else {

                tl.add(Animations.revealElements(videoEl, { y: 0 }, { duration: 1, yPercent: 0 }));
            }

        });


        if (!videoEl) return;

        const videoModule = VideoModule.initialize(videoEl);

        /* let played = false; */

        ScrollTrigger.create({
            id: 'hero',
            trigger: module,
            start: () => `top top+=${Header.getCurrentHeight()}`,
            end: 'bottom top',
            invalidateOnRefresh: true,
            /* markers: true, */
            onToggle: async self => {
                if (self.isActive /* && !played */) {
                    try {
                        await videoModule.load()
                        videoModule.play();

                    } catch (err) {
                        console.error(err);
                    }
                    /* played = true; */
                } else {
                    videoModule.reset();
                    videoModule.revealPoster();
                }
            },
        });



        const handleVideoEnded = () => {
            videoModule.revealPoster();
        };

        // handle case when user hits the play btn
        const handleVideoPlay = () => {
            Animations.hideElements(videoModule.poster, {}, { y: 0 });
        };

        videoModule.video?.addEventListener("ended", handleVideoEnded);
        videoModule.video?.addEventListener("play", handleVideoPlay);

    };




    return {
        initialize
    }

})();


export default Hero;